import(/* webpackMode: "eager" */ "/app/src/app/mimosa-brookfield/call-ahead/page.tsx");
